import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useConvexMutation } from './use-convex-mutation';

// ════════════════════════════════════════════════════════════
// QUERY HOOKS
// ════════════════════════════════════════════════════════════

export function useSessionNotes(sessionId: string) {
  const data = useQuery(
    api.coach.notes.getForSession,
    sessionId ? { sessionId: sessionId as Id<"trainingSessions"> } : 'skip'
  );
  return { data, isLoading: data === undefined, error: null };
}

// ════════════════════════════════════════════════════════════
// MUTATION HOOKS
// ════════════════════════════════════════════════════════════

export function useSaveSessionNotes(sessionId: string) {
  const { mutateAsync, isPending } = useConvexMutation(api.coach.notes.save);
  return {
    isPending,
    mutateAsync: (note: string) => mutateAsync({ sessionId: sessionId as Id<"trainingSessions">, note }),
  };
}
